export function secondsToStr (temp) {
  const years = Math.floor(temp / 31536000)
  if (years) {
    return years + ' year' + numberEnding(years)
  }
  const days = Math.floor((temp %= 31536000) / 86400)
  if (days) {
    return days + ' day' + numberEnding(days)
  }
  const hours = Math.floor((temp %= 86400) / 3600)
  if (hours) {
    return hours + ' hour' + numberEnding(hours)
  }
  const minutes = Math.floor((temp %= 3600) / 60)
  if (minutes) {
    return minutes + ' minute' + numberEnding(minutes)
  }
  const seconds = temp % 60
  return seconds + ' second' + numberEnding(seconds)
  function numberEnding (number) {
    return (number > 1) ? 's' : ''
  }
}

export function kebabCase (s) {
  return s.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`)
}

const video = ['wmv', 'asf', 'asx', 'rm', 'rmvb', 'mp4', '3gp', 'mov', 'm4v', 'avi', 'dat', 'mkv', 'flv', 'vob']
const music = ['cd', 'wave', 'aiff', 'mpeg', 'mp3', 'mpeg-4', 'midi', 'wma', 'vqf', 'amr', 'ape', 'flac', 'aac']
const img = ['png', 'gif', 'jpg', 'jpeg', 'bmp', 'tiff']
const code = ['js', 'vue', 'css', 'java', 'php', 'py', 'svg', 'json', 'cpp', 'c', 'h', 'hpp', 'xml', 'xhtml']
const zip = ['zip', 'rar', '7z', 'gz', 'jar', 'war']
const word = ['doc', 'docx', 'dotx', 'dot', 'docm', 'dotm']
const excel = ['xls', 'xlsx', 'xlsb', 'xlsm', 'xlst', 'csv']
const ppt = ['ppt', 'pps', 'pptx', 'ppsx', 'pot', 'ppa']
const cd = ['dvd', 'iso']
const txt = ['txt', 'log']
const iconPrefix = '#'

/**
 * 获取文件类型对应的图标
 */
export function type2Icon (type, isFolder = false) {
  if (!type) return `${iconPrefix}icon-file_cloud`
  if (isFolder) return `${iconPrefix}icon-folder`
  let t = type.toLowerCase()
  if (zip.indexOf(t) !== -1) return `${iconPrefix}icon-file_zip`
  if (img.indexOf(t) !== -1) return `${iconPrefix}icon-file_img`
  if (word.indexOf(t) !== -1) return `${iconPrefix}icon-file_word`
  if (excel.indexOf(t) !== -1) return `${iconPrefix}icon-file_excel`
  if (ppt.indexOf(t) !== -1) return `${iconPrefix}icon-file_ppt`
  if (video.indexOf(t) !== -1) return `${iconPrefix}icon-file_video`
  if (music.indexOf(t) !== -1) return `${iconPrefix}icon-file_music`
  if (code.indexOf(t) !== -1) return `${iconPrefix}icon-file_code`
  if (cd.indexOf(t) !== -1) return `${iconPrefix}icon-file_iso`
  if (txt.indexOf(t) !== -1) return `${iconPrefix}icon-file_txt`
  if (t === 'pdf') return `${iconPrefix}icon-file_pdf`
  if (t === 'exe') return `${iconPrefix}icon-file_exe`
  if (t === 'html') return `${iconPrefix}icon-file_html`
  if (t === 'swf') return `${iconPrefix}icon-file_flash`
  if (t === 'cad') return `${iconPrefix}icon-file_cad`
  if (t === 'psd') return `${iconPrefix}icon-file_ps`
  if (t === 'ai') return `${iconPrefix}icon-file_ai`
  if (t === 'bt') return `${iconPrefix}icon-file_bt`
  return `${iconPrefix}icon-file_cloud`
}

export function formatSize (size) {
  if (isNaN(size)) return ''
  size = Number(size)
  if (size < 1024) {
    return size.toFixed(0) + ' bytes'
  } else if (size < 1024 * 1024) {
    return (size / 1024.0).toFixed(0) + ' KB'
  } else if (size < 1024 * 1024 * 1024) {
    return (size / 1024.0 / 1024.0).toFixed(1) + ' MB'
  } else {
    return (size / 1024.0 / 1024.0 / 1024.0).toFixed(1) + ' GB'
  }
}



// WEBPACK FOOTER //
// ./src/components/framework/uploader/common/utils.js